import { getById, getAll, get } from "@/utilities/querySelector";

const form = getById('archive-filters');

if (form) {
    form.addEventListener('change', function() {
        const hasFilters = Array.from(new FormData(this).values()).some(value => value !== '');
        getById('reset-filters').classList.toggle('active', hasFilters);
    });

    window.resetFilters = function(event) {
        event.preventDefault();
        getAll('nu-dropdown', form).forEach(dropdown => {
            const select = get('select', dropdown);
            const valueSpan = get('.dropdown-value', dropdown);

            if (dropdown.getAttribute('data-type') === 'date-range') {
                const fromInput = dropdown.querySelector('input[type="hidden"]:first-of-type');
                const toInput = dropdown.querySelector('input[type="hidden"]:last-of-type');
                const button = dropdown.querySelector('.dropdown-button');

                if (button._flatpickr) {
                    button._flatpickr.clear();
                }

                fromInput.value = '';
                toInput.value = '';
                valueSpan.textContent = 'Select Dates';
            } else {
                select.value = '';
                valueSpan.textContent = 'Show all';
            }
        });

        getById('reset-filters').classList.remove('active');
        htmx.trigger(form, 'submit');
    };
}
